var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-gift-container"},[_c('CategoryTitle',{attrs:{"category":_vm.category}}),_c('GiftList',{attrs:{"mode":'checkout'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }